import { useTranslation } from 'react-i18next';
import { SimSubscriptionStatusChart } from './SimSubscriptionStatusChart';
import { DoughnutChartWidget } from 'src/common/components/Graphs/common/Graphs/components/DoughnutChartWidget';
import { accountsFilterAtom } from 'src/atoms/filters/sim-products';
import { GraphAccountsValidator } from 'src/products/GraphAccountValidator';
import { useAccountRefs } from 'src/common/components/Accounts/useAccountRefs';
import { SubscriptionStateChartPlaceholder } from 'src/products/GraphValidatorPlaceholders';

export const SimSubscriptionStatusChartWidget = () => {
  const { t } = useTranslation();
  const accountRefs = useAccountRefs({ cslAccountAtom: accountsFilterAtom });

  const title = t('dashboard.subscriptionsStatusChart.title');

  return (
    <GraphAccountsValidator
      accountRefs={accountRefs}
      fallback={<SubscriptionStateChartPlaceholder title={title} />}
    >
      <DoughnutChartWidget title={title} accountRef={accountRefs[0]}>
        {(accountRef) => <SimSubscriptionStatusChart accountRef={accountRef} />}
      </DoughnutChartWidget>
    </GraphAccountsValidator>
  );
};
